import { useMutation, useQuery } from "@apollo/client";
import {
  Box,
  Button,
  Container,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import CloseIcon from "@material-ui/icons/Close";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import React, { useContext, useState } from "react";
import { ProcessGrapqlError } from "..";
import { Context } from "../store";
import {
  AlertDialog,
  HalfScreenDialog,
  UpdateStaff,
} from "../_components";
import { AlertHelper, LoaderHelper } from "../_helpers";
import { DELETE_STAFF, GET_STAFFS } from "../_queries";
import { Colors } from "../_constants";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    "& > *": {
      marginRight: theme.spacing(1),
    },
  },
  table: {
    minWidth: 650,
  },
  bredcrumb: {
    backgroundColor: `${Colors.WHITE}`,
    marginBottom: "15px",
    borderRadius: "5px",
  },
  bredcrumbTitle: {
    fontSize: "16px",
    fontWeight: "600",
  },
  tableHeader: {
    backgroundColor: `${Colors.SECONDARY_LIGHT}`,
    padding: "15px",
  },
}));
export const Staff = () => {
  const classes = useStyles();
  const { state, setGlobalState } = useContext(Context);
  const [deleting, setDeleting] = useState(false);
  const [ref_id, setRefId] = useState("0");
  const [DeleteBranch] = useMutation(DELETE_STAFF, {
    onCompleted() {
      AlertHelper.success("Successfully deleted!");
    },
    onError(error) {
      ProcessGrapqlError(error);
    },
  });
  const Delete = (id) => {
    setRefId(id);
    setDeleting(true);
  };
  const Negative = () => {
    setRefId("0");
    setDeleting(false);
  };
  const Positive = () => {
    setDeleting(false);
    AlertHelper.progress("Deleting...");
    DeleteBranch({
      variables: { user_id: ref_id },
      update(cache) {
        const existing = cache.readQuery({ query: GET_STAFFS });
        const newStaffs = existing.Staffs.filter(
          (item) => item.user_id !== ref_id
        );
        cache.writeQuery({
          query: GET_STAFFS,
          data: { Staffs: newStaffs },
        });
      },
    });
  };

  const DataLists = () => {
    const { loading, error, data } = useQuery(GET_STAFFS);
    if (loading) {
      LoaderHelper.load();
    } else {
      LoaderHelper.clear();
    }
    if (error) {
      ProcessGrapqlError(error);
    }

    return (
      <>
        <List className={classes.bredcrumb}>
          <ListItem>
            <ListItemText
              primary={
                <span className={classes.bredcrumbTitle}>Staff list</span>
              }
              secondary="Add Staff here"
            />
            <ListItemSecondaryAction>
              <Button
                startIcon={<AddBoxIcon />}
                onClick={() => {
                  setGlobalState({
                    ...state,
                    staff_adding: true,
                    editing_staff: false,
                  });
                }}
                variant={"text"}
                color={"primary"}
              >
                Add New
              </Button>
            </ListItemSecondaryAction>
          </ListItem>
        </List>
        <TableContainer component={Paper}>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeader}>
                  Staff name
                </TableCell>
                <TableCell className={classes.tableHeader}>Email</TableCell>
                <TableCell className={classes.tableHeader}>Mobile</TableCell>
                <TableCell className={classes.tableHeader}>Role</TableCell>
                <TableCell className={classes.tableHeader}>Action</TableCell>
                <TableCell className={classes.tableHeader}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.Staffs.map((row) => (
                  <TableRow key={row.user_id}>
                    <TableCell component="th" scope="row">
                      {row.fullname}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.mobile}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.role.role_name}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => {
                          setGlobalState({
                            ...state,
                            edit_staff: row,
                            editing_staff: true,
                            staff_adding: true,
                          });
                        }}
                        aria-label="delete"
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        onClick={() => Delete(row.user_id)}
                        aria-label="delete"
                      >
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    );
  };
  return (
    <>
      {deleting && (
        <AlertDialog
          open={true}
          negative={Negative}
          positive={Positive}
          title={"Warning"}
          description={"Are you sure you want to delete?"}
        />
      )}
      {state.staff_adding && (
        <HalfScreenDialog
          open={true}
          component={<UpdateStaff />}
          CloseCallback={() => {
            setGlobalState({
              ...state,
              staff_adding: false,
            });
          }}
        />
      )}
      <Container maxWidth={false}>
        <Box className={classes.container}>
          <DataLists />
        </Box>
      </Container>
    </>
  );
};
